module.exports = __webpack_public_path__ + "c6f303a36b08ba17ca6ad60d91d43e30.svg";